import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, interval, Observable, Subject } from 'rxjs';
import { delay, distinctUntilChanged, takeUntil, takeWhile } from 'rxjs/operators';
import { ApiConectateService } from '../../../../api/apiConectate';
import { ApiTokboxService } from '../../../../api/apiTokbox/apiTokbox.service';
import { EVENTS_CONSTANTS } from '../../../../constants/events.constants';
import { Room, RoomSchedule } from '../../../../models';
import { VIDEOCONFERENCE_CONSTANTS } from '../../../../constants/videoconference.constants';
import { PARTICIPANTS_CONSTANTS } from '../../../../constants/participants.constants';
import { StateHandlerService } from '../../../../services/state-handler/state-handler.service';
import { EnvironmentService } from '../../../../services/enviroment/environment.service';
import { UtilsService } from '../../../../services/utils/utils.service';
import { SessionStorageService } from '../../../../services/session-storage/session-storage.service';
import { TooltipSupportService } from '../../../../services/tooltip-support/tooltip-support.service';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { AsyncPipe, NgClass } from '@angular/common';
import { SupportTooltipComponent } from '../../../../components/support-tooltip/support-tooltip.component';
import { environment } from '../../../../../environments/environment';

// Add interface to extend HTMLAudioElement with setSinkId method
interface HTMLMediaElementWithSinkId extends HTMLMediaElement {
  setSinkId(deviceId: string): Promise<void>;
}

/**
 * Componenete de la antesala de reunión de videoconferencia.
 * Funciones:
 * - Controla la habilitación o no de video o audio antes de entrar en la videoconferencia.
 * - Introducción de pin si es necesario.
 */
@Component({
  standalone: true,
  imports: [
    TranslatePipe,
    TranslateDirective,
    NgClass,
    AsyncPipe,
    ReactiveFormsModule,
    SupportTooltipComponent
  ],
  selector: 'sas-disconnected',
  templateUrl: './disconnected.component.html',
  styleUrls: ['./disconnected.component.scss']
})

export class DisconnectedComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('publisherDiv') publisherDiv?: ElementRef;
  @Input() reason?: string;
  @Input() roomSchedule?: RoomSchedule;
  @Output() connect: EventEmitter<any> = new EventEmitter();
  @Output() authentication: EventEmitter<string> = new EventEmitter();
  @Output() waitingtRoomPublisher: EventEmitter<OT.Publisher> = new EventEmitter();
  @Output() reConnect: EventEmitter<boolean> = new EventEmitter();
  @Input() session?: OT.Session;
  @Input() roomData?: Room;
  @Input() invalidPassword?: boolean;
  @Input() forcePublisherOff?: boolean;

  /**
   * support phone
   */
  hide: boolean = true;
  supportPhone: string;

  AVAILABLE_CONNECTION_SCORE = 3.1;
  signInForm?: FormGroup;
  publishing: boolean = true;
  publisher?: OT.Publisher;
  ot: any;
  /**
   * Variable para el control del estado del video (habilitado/deahabilitado) con el slider
   * del widget audio/video de la antesala.
   */
  private videoEnabledBS: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public videoEnabled$: Observable<boolean> = this.videoEnabledBS.asObservable().pipe(
    delay(100),
    distinctUntilChanged()
  );
  /**
   * Variable para el control del estado del audio (habilitado/deahabilitado) con el slider
   * del widget audio/video de la antesala.
   */
  private audioEnabledBS: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public audioEnabled$: Observable<boolean> = this.audioEnabledBS.asObservable().pipe(
    delay(100),
    distinctUntilChanged()
  );
  startDate: any;
  devicesTestActivate?: boolean;
  enabledSurvey?: boolean;
  surveyDone?: boolean;
  pinRequiered?: boolean;
  mySelf:  string = '';
  participantsNames: any;
  otherParticipants: Array<any> = [];
  roleType: string = '';
  disconnectedStatus = VIDEOCONFERENCE_CONSTANTS.DISCONNECTED_STATUS;
  audioLevelCont = 0;
  urlPin = '';
  ROLES_TYPE = PARTICIPANTS_CONSTANTS.ROL_TYPE;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  private events = EVENTS_CONSTANTS;
  audioDevices: any;
  videoDevices: any;
  selectedCam: any;
  selectedMic: any;
  isPatient: boolean = false;

  /**
   * Método que abre el supportNumberTooltip.
   */
  public showSupportNumber() {
    this.tooltipSupportService.setCloseOpenTooltipSupport(true);
  }

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly activatedRoute: ActivatedRoute,
    private readonly opentokService: ApiTokboxService,
    private readonly apiConectateService: ApiConectateService,
    private readonly stateHandlerSrv: StateHandlerService,
    private readonly enviroment: EnvironmentService,
    private readonly fb: FormBuilder,
    private readonly utilsService: UtilsService,
    private readonly sessionStorageSrv: SessionStorageService,
    private readonly tooltipSupportService: TooltipSupportService,
    private readonly utils: UtilsService
  ) {
      this.supportPhone = this.enviroment.data.tech_support_phone;
      this.isPatient = environment.isPatient;
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (changes?.forcePublisherOff?.currentValue) {
    //   console.log('disconnect ngOnChanges[forcePublisherOff] publisher.off', changes.forcePublisherOff);
    //   this.publisher?.off();
    // }
  }
  ngOnInit() {
    if(environment.isPatient){
      //Obtenemos los dispositivos de audio y video.
      this.getHardwares();
      // RECUPERAMOS EL PIN DE LA SESION
      this.urlPin = this.sessionStorageSrv.get('s');
    }
    this.participantsNames = {};
    //Control por configuración del test de conexión.
    this.devicesTestActivate =
      this.enviroment.data?.features?.audio_test &&
      this.enviroment.data?.features?.network_test;

    this.stateHandlerSrv.get('surveyDone').pipe(takeUntil(this.ngUnsubscribe)).subscribe((data) => {
      this.surveyDone = data;
      this.cdr.detectChanges();
    });
    //Se obtienen los valores de la sala.
    this.stateHandlerSrv.get('roomData').pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: Room) => {
      if (response) {
        this.roomData = response;
        this.enabledSurvey =
          this.enviroment.data?.features?.survey_active &&
          this.roomData?.activeSurvey &&
          !this.roomData?.surveyAnswered;
        this.cdr.detectChanges();
      }
    });

    //Variable para el control de entrada a la videoconferencia si se necesita pin, por config del aplicativo.
    if(environment.isPatient){
      this.pinRequiered = this.enviroment.data?.features?.pin_required && !this.urlPin;;
    }else{
      this.pinRequiered = this.enviroment.data?.features?.pin_required;
    }
    this.attendantsData();
    this.initData();
  }

  ngAfterViewInit() {
    this.init();
  }

  /**
   * Método para inicializar el publisher (servidor de publicaciones de la videoconferencia).
   */
  async init() {
    this.selectedCam = localStorage.getItem('selectedCam');
    this.selectedMic = localStorage.getItem('selectedMic');
    this.ot = this.opentokService.getOT();
    console.log('disconnected initPublisher() (' + this.utilsService.getTodayWithHour() + ') OT Object:', this.ot);
    console.log('disconnected initPublisher() videoEnabled(' + 'this.videoEnabledBS.getValue()');
    console.log('disconnected initPublisher() audioEnabled(' + 'this.audioEnabledBS.getValue()');

    await this.getHardwares();
    if (this.publisherDiv) {
      this.publisher = this.ot.initPublisher(this.publisherDiv.nativeElement, {
        width: '',
        height: '',
        insertMode: 'append',
        style: {
          audioLevelDisplayMode: 'off',
          buttonDisplayMode: 'off',
          nameDisplayMode: 'on'
        },
        showControls: true,
        publishAudio: true,
        videoSource: this.selectedCam.deviceId,
        audioSource: this.selectedMic.deviceId,
      }, (error:any) => {
        if (error) {
          console.log('initPublisher error: ', error);
        } else {
          if(environment.isPatient){
            console.log('disconnected init() initPublisher-response --> publisher.off() (' + this.utilsService.getTodayWithHour()+')');
            this.publisher?.off('audioLevelUpdated');
          }
          this.enableDevices();
          this.audioLevel();
        }
        this.cdr.detectChanges();
      });
    }
  }

  /**
   * Formulario para la introducción del pin de la videoconferencia.
   */
  initForm() {
    this.signInForm = this.fb.group({
      password: new FormControl(null, [Validators.required]),
    });
    if(environment.isPatient && this.urlPin){
      this.signInForm.get('password')?.setValue(this.urlPin);
      this.sendPassword();
    }
    this.cdr.detectChanges();
  }

  /**
   * Se obtienen los valores de los participantes.
   */
  attendantsData() {
    const attendantId =
      this.activatedRoute.snapshot.queryParams[
        VIDEOCONFERENCE_CONSTANTS.URL_PARAM_ATTENDANT
      ];

    this.apiConectateService
      .getAttendants(attendantId)
      .subscribe((res: any) => {
        if (res) {
          this.mySelf = decodeURIComponent(escape(atob(res?.self?.c)));
          this.roleType = res?.self?.b;
          this.otherParticipants = Object.assign([], res?.others);
          this.setAttendantsDataByRoleType(this.roleType);
          this.cdr.detectChanges();
        }
      });
  }

  setAttendantsDataByRoleType(roleType: string) {
    const otherParticipantsSize = this.otherParticipants?.length;

    if (roleType === this.ROLES_TYPE.AMPHITRYON_SHORT) {
      if (otherParticipantsSize === 1) {
        this.participantsNames[this.ROLES_TYPE.USER_SHORT] = decodeURIComponent(
          escape(atob(this.otherParticipants[0].c))
        );
      }

      if (otherParticipantsSize > 1) {
        this.participantsNames[this.ROLES_TYPE.USER_SHORT] = '';
        for (let i = 0; i < otherParticipantsSize; i++) {
          if (this.otherParticipants[i].b === this.ROLES_TYPE.USER_SHORT) {
            this.participantsNames[this.ROLES_TYPE.USER_SHORT] =
              this.participantsNames[this.ROLES_TYPE.USER_SHORT] +
              decodeURIComponent(escape(atob(this.otherParticipants[i].c))) +
              ', ';
          }
        }

        this.participantsNames[this.ROLES_TYPE.USER_SHORT] =
          this.participantsNames[this.ROLES_TYPE.USER_SHORT].slice(0, -2);
      }
    }

    if (roleType === this.ROLES_TYPE.USER_SHORT) {
      for (let i = 0; i < otherParticipantsSize; i++) {
        if (this.otherParticipants[i].b === this.ROLES_TYPE.AMPHITRYON_SHORT) {
          this.participantsNames[this.ROLES_TYPE.AMPHITRYON_SHORT] =
            decodeURIComponent(escape(atob(this.otherParticipants[i].c)));
        }
      }
    }
  }

  enableDevices() {
    this.audioEnabledBS.next(true);
    this.videoEnabledBS.next(true);
    console.log(
      'disconnected publisher.publishAudio(' +
        this.audioEnabledBS.getValue() +
        ') (' +
        this.utilsService.getTodayWithHour() +
        ')'
    );
    console.log(
      'disconnected publisher.publishVideo(' +
        this.videoEnabledBS.getValue() +
        ') (' +
        this.utilsService.getTodayWithHour() +
        ')'
    );
    this.publisher?.publishAudio(this.audioEnabledBS.getValue());
    this.publisher?.publishVideo(this.videoEnabledBS.getValue());
    this.stateHandlerSrv.set('cameraButtonState', true);
    this.stateHandlerSrv.set('microButtonState', true);
    this.sessionStorageSrv.set('cameraButtonState', true);
    this.sessionStorageSrv.set('microButtonState', true);
    this.cdr.detectChanges();
  }

  disableVideo() {
    this.videoEnabledBS.next(false);
    console.log(
      'disconnected publisher.publishVideo(' +
        this.videoEnabledBS.getValue() +
        ') (' +
        this.utilsService.getTodayWithHour() +
        ')'
    );
    this.publisher?.publishVideo(this.videoEnabledBS.getValue());
    this.stateHandlerSrv.set('cameraButtonState', false);
    this.cdr.detectChanges();
  }

  sendPassword() {
    if (this.signInForm && this.signInForm.valid) {
      this.authentication.emit(this.signInForm.controls['password'].value);
      if(environment.isPatient){
        this.stateHandlerSrv.set('urlPin', null);
        this.urlPin = '';
      }
      this.cdr.detectChanges();
    }
  }

  // Method that check the audio Level for the meter of audio
  audioLevel() {
    let movingAvg:any = null;
    console.log('disconnected audioLevel publisher.on(audioLevelUpdated) (' + this.utilsService.getTodayWithHour()+')');
    if(!this.publisher) return;

    this.publisher.on('audioLevelUpdated', (event) => {
      if (movingAvg === null || movingAvg <= event.audioLevel) {
        movingAvg = event.audioLevel;
      } else {
        movingAvg = 0.7 * movingAvg + 0.3 * event.audioLevel;
      }
      // 1.5 scaling to map the -30 - 0 dBm range to [0,1]
      let logLevel = (Math.log(movingAvg) / Math.LN10) / 1.5 + 1;
      logLevel = Math.min(Math.max(logLevel, 0), 1);
      if (<HTMLInputElement>document.querySelector('#publisherMeter')) {
        (<HTMLInputElement>document.querySelector('#publisherMeter')).value = logLevel?.toString();
      }
      if (this.audioLevelCont % 80 === 0) {
        console.log('********** disconnected audioLevelUpdated **************');
        console.log('disconnected audioLevelUpdated eventLevel:' + event.audioLevel);
        console.log('disconnected audioLevelUpdated logLevel:', logLevel);
        console.log('disconnected audioLevelUpdated movingAvg:', movingAvg);
        console.log('********** END disconnected audioLevelUpdated **************');
      }
      this.audioLevelCont++;
    }, this);

    this.waitingtRoomPublisher.emit(this.publisher);
    this.cdr.detectChanges();
  }

  publish() {
    if(!this.publisher) return;
    this.session?.publish(this.publisher, (err) => {
      if (err) {
        console.log(
          'error Publishing session: (' + this.utils.getTodayWithHour() + ') ',
          err
        );
      } else {
        this.publishing = true;
        

        //TODO?: !environment.isPatient
        // Set audio output device (headset)
        const selectedHeadset = localStorage.getItem('selectedHeadset');
        if (selectedHeadset) {
          // Find the audio element inside the publisher's DOM element
          const element = this.publisher?.element?.querySelector('audio') as HTMLMediaElementWithSinkId;
          if (element && typeof element.setSinkId === 'function') {
            element.setSinkId(selectedHeadset)
              .then(() => console.log('Audio output device set successfully'))
              .catch(error => console.error('Error setting audio output device', error));
          }
        }
      }
    });
    //TODO?: !environment.isPatient
    this.publisher.setVideoSource(localStorage.getItem('selectedCam') || '')
    this.publisher.setAudioSource(localStorage.getItem('selectedMic') || '')
    this.cdr.detectChanges();
  }

  /**
   * Emite evento de reconexión.
   */
  reconnect() {
    console.log('disconnected reconect (' + this.utilsService.getTodayWithHour()+')');
    this.reConnect.emit(true);
    this.cdr.detectChanges();
  }

  /**
   * Cambio de cámara
   */
  changeCamera(ev: any) {
    this.videoEnabledBS.next(ev.target.checked);
    console.log('disconnected changeCamera publisher.publishVideo('+this.videoEnabledBS.getValue()+') (' + this.utilsService.getTodayWithHour()+')');
    this.publisher?.publishVideo(this.videoEnabledBS.getValue());
    this.stateHandlerSrv.set('cameraButtonState', ev.target.checked);
    this.cdr.detectChanges();
  }

  /**
   * Cambio en slider del audio
   */
  changeMicro(ev:any) {
    this.audioEnabledBS.next(ev.target.checked);
    console.log('disconnected changeMicro publisher.publishVideo('+this.videoEnabledBS.getValue()+') (' + this.utilsService.getTodayWithHour()+')');
    this.publisher?.publishAudio(this.audioEnabledBS.getValue());
    this.stateHandlerSrv.set('microButtonState', ev.target.checked);
    this.cdr.detectChanges();
  }

  goToSurvey() {
    console.log('disconnected goToSurvey publisher.off() (' + this.utilsService.getTodayWithHour()+')');
    this.publisher?.off();
    this.stateHandlerSrv.set('goToSurvey', true);
    this.cdr.detectChanges();
  }

  private calculateRemainingTime() {
    if(!this.roomSchedule) return;
    const courtesySeconds = 60;
    const currentDate = new Date();
    const startsAtDate = new Date(this.roomSchedule.startsAt);
    const diff = startsAtDate.getTime() - currentDate.getTime();
    let remainingSeconds = (Math.round(Math.abs(diff / 1000)) - this.roomSchedule.delta) + courtesySeconds;
    const source = interval(1000).pipe(takeWhile(() => remainingSeconds !== 0));
    source.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      remainingSeconds -= 1;

      if (remainingSeconds <= 0) {
        this.pinRequiered ? this.reason = 'password_required' : this.authentication.emit('');
      }
    });
  }

  private initData() {
    this.stateHandlerSrv.set('intoRoomDisconnected', true);
    this.stateHandlerSrv.set('microButtonState', true);
    this.stateHandlerSrv.set('cameraButtonState', true);
    this.initForm();
    this.stateHandlerSrv.get('disconnected_status').pipe(takeUntil(this.ngUnsubscribe)).subscribe((disconnectedStatus) => {
      console.log('disconnected initData stateHandlerSrv.get(\'disconnected_status\') (' + this.utilsService.getTodayWithHour()+') status', disconnectedStatus);
      if (disconnectedStatus) {
        this.reason = disconnectedStatus;
      }
    });


       // DETECTAMOS SI TENEMOS EL ID ALMACENADO EN LA SESSION
    //     SI ES ASI INSERTAMOS EN EL STATEHANDLERSRV EL WAITING PARA QUE MUESTRE EL TEXTO DE ESPERA
    //     EN CASO NEGATIVO PASA Y CONTINUA LA EJECUCION NORMAL
    if (environment.isPatient && this.sessionStorageSrv.get('s')) {
      this.stateHandlerSrv.set('waiting', 'waiting');
      this.stateHandlerSrv.get('waiting').pipe(takeUntil(this.ngUnsubscribe)).subscribe((waiting) => {
        console.log('waiting initData stateHandlerSrv.get(\'waiting\') (' + this.utilsService.getTodayWithHour() + ') status', waiting);
        this.reason = waiting;
      })
    }


    this.stateHandlerSrv.get('roomSchedule').pipe(takeUntil(this.ngUnsubscribe)).subscribe((roomSchedule) => {
      console.log('disconnected initdata stateHandlerSrv.get(\'roomSchedule\') (' + this.utilsService.getTodayWithHour()+') roomSchedule', roomSchedule);
      if (roomSchedule) {
        this.roomSchedule = roomSchedule;
        this.startDate = this.formatDate();
        if (this.roomSchedule?.status === this.disconnectedStatus.NOT_STARTED) {
          if(this.reason !== VIDEOCONFERENCE_CONSTANTS.DISCONNECTED_STATUS.NOT_FOUND){
            this.reason = this.roomSchedule?.status;
          }
          this.calculateRemainingTime();
        }
      }
    });
  }

  private formatDate() {
    if(!this.roomSchedule) return;
    const date = new Date(this.roomSchedule.startsAt);
    return {
      day: date.getDate(),
      month: VIDEOCONFERENCE_CONSTANTS.MONTHS[date.getMonth()],
      year: date.getFullYear(),
      hour: this.formatTime(date.getHours()),
      minute: this.formatTime(date.getMinutes())
    };
  }

  private formatTime(n: number):string {
    let nu = n+''
    if (n < 10) {
      nu = '0' + n;
    }
    return nu;
  }

  getHardwares() {
    return new Promise((resolve) => {
      this.utils.getHardwareDevices(this.ot).pipe(takeUntil(this.ngUnsubscribe)).subscribe((devices) => {
        if (devices && devices.audioList) {
          this.audioDevices = devices.audioList;
        }
        if (devices && devices.videoList) {
          this.videoDevices = devices.videoList;
          this.selectedCam = this.videoDevices.find((device: any) => device.deviceId === this.selectedCam);
        }
        resolve(true); // Indica que `getHardwares()` ha finalizado
      });
    });
  }

  ngOnDestroy(): void {
    console.log('disconnected ngOnDestroy publisher.off() (' + this.utilsService.getTodayWithHour()+')');
    this.publisher?.off();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
